/**
 * 商品ページの購入まわり（sections/product-template.liquid の右カラム）
 *
 * - オプションのカード（radio）で選んだ値を、theme.js の Variants が見ている見えないセレクト
 *   （.single-option-selector-<セクションID>）に写す。バリエーションの切り替え・カートボタン・価格の
 *   書き換え・URL の ?variant= は theme.js に任せ、ページは読み込み直さない
 * - カードの在庫切れ・取り扱いなし、見出し価格の「／ 主オプション」、合計パネル、数量の −／＋ はここで更新する
 * - スマホでは合計パネルが画面下の固定バーになる。バーの高さぶんページ下部に余白を取る
 *   （画面下の LINE ボタンは、バーが出ているあいだ CSS で隠し、バーの中のボタンにまとめている）
 * - 関連商品が多い商品では、デスクトップで残りを「ほかの関連商品を見る」で開く
 */
(function() {
  'use strict';

  var MOBILE_QUERY = 'screen and (max-width: 749px)';
  var NOTE_SOLD_OUT = '在庫切れ';
  var NOTE_UNAVAILABLE = '取り扱いなし';

  function formatMoney(cents) {
    return theme.Currency.formatMoney(cents, theme.moneyFormat);
  }

  function init(root) {
    initRelated(root);

    var sectionId = root.getAttribute('data-section-id');
    var productJson = document.getElementById('ProductJson-' + sectionId);

    if (!productJson || !productJson.textContent.length) {
      return;
    }

    var product = JSON.parse(productJson.textContent);
    var groups = Array.prototype.slice.call(
      root.querySelectorAll('[data-product-option]')
    );
    var selects = root.querySelectorAll('.single-option-selector-' + sectionId);
    var quantityInput = root.querySelector('[data-quantity-input]');
    var stepButtons = root.querySelectorAll('[data-quantity-step]');
    var primaryOption = root.querySelector('[data-primary-option]');
    var comparePrice = root.querySelector('[data-compare-price]');
    var selection = root.querySelector('[data-purchase-selection]');
    var total = root.querySelector('[data-purchase-total]');
    var bar = root.querySelector('[data-purchase-bar]');

    function getSelectedValues() {
      return groups.map(function(group) {
        var checked = group.querySelector('input[type="radio"]:checked');

        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      if (!values.length) {
        return product.variants[0];
      }

      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var matches = values.every(function(value, index) {
          return variant.options[index] === value;
        });

        if (matches) {
          return variant;
        }
      }

      return null;
    }

    function getQuantity() {
      if (!quantityInput) {
        return 1;
      }

      var quantity = parseInt(quantityInput.value, 10);

      return isNaN(quantity) || quantity < 0 ? 0 : quantity;
    }

    // 各カードは「その値 ＋ ほかのオプションのいまの値」の組み合わせで判定する（Liquid の初期表示と同じ）。
    // 選べない組み合わせは disabled にするが、選択中のカードは外せなくならないよう disabled にしない
    function updateCards(selected) {
      groups.forEach(function(group, groupIndex) {
        var inputs = group.querySelectorAll('input[type="radio"]');

        Array.prototype.forEach.call(inputs, function(input) {
          var values = selected.slice();
          values[groupIndex] = input.value;

          var variant = findVariant(values);
          var state = !variant
            ? 'unavailable'
            : variant.available
            ? 'available'
            : 'sold-out';
          var card = input.closest('[data-option-card]');
          var note = card.querySelector('[data-option-note]');

          card.classList.toggle('product-option__card--sold-out', state === 'sold-out');
          card.classList.toggle('product-option__card--unavailable', state === 'unavailable');
          input.disabled = state !== 'available' && !input.checked;

          // 価格は出さない（見出しの価格と合計で分かる）。選べないときだけ理由を出す
          if (state === 'available') {
            note.textContent = '';
          } else {
            note.textContent = state === 'sold-out' ? NOTE_SOLD_OUT : NOTE_UNAVAILABLE;
          }
        });
      });
    }

    function update() {
      var selected = getSelectedValues();
      var variant = findVariant(selected);
      var quantity = getQuantity();
      var amount = variant ? formatMoney(variant.price * quantity) : '—';

      updateCards(selected);

      if (primaryOption && selected[0] !== null) {
        primaryOption.textContent = '／ ' + selected[0];
      }

      if (comparePrice && variant && variant.compare_at_price > variant.price) {
        comparePrice.textContent = formatMoney(variant.compare_at_price);
      }

      selection.textContent = selected
        .filter(function(value) {
          return value !== null;
        })
        .concat(quantity + '点')
        .join('・');

      // aria-live で読み上げるため、変わったときだけ書き換える
      if (total.textContent !== amount) {
        total.textContent = amount;
      }

      Array.prototype.forEach.call(stepButtons, function(button) {
        if (Number(button.getAttribute('data-quantity-step')) < 0) {
          button.disabled = quantity <= 1;
        }
      });
    }

    groups.forEach(function(group, groupIndex) {
      group.addEventListener('change', function(event) {
        var input = event.target;
        var select = selects[groupIndex];

        if (input.type !== 'radio') {
          return;
        }

        if (select && select.value !== input.value) {
          select.value = input.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        update();
      });
    });

    if (quantityInput) {
      Array.prototype.forEach.call(stepButtons, function(button) {
        button.addEventListener('click', function() {
          var step = Number(button.getAttribute('data-quantity-step'));

          quantityInput.value = Math.max(1, getQuantity() + step);
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

          // 1 になって − が disabled になると、押したボタンからフォーカスが外れるので ＋ に移す
          if (button.disabled) {
            Array.prototype.forEach.call(stepButtons, function(other) {
              if (!other.disabled) {
                other.focus();
              }
            });
          }
        });
      });

      quantityInput.addEventListener('input', update);
      quantityInput.addEventListener('change', update);
    }

    // 戻るボタンでページが復元されたとき、ブラウザが入力欄の値だけ戻すことがある
    window.addEventListener('pageshow', update);
    update();

    if (bar) {
      initBar(bar);
    }
  }

  function initBar(bar) {
    var mobile = window.matchMedia(MOBILE_QUERY);

    function layout() {
      var body = document.body;

      if (!mobile.matches) {
        body.classList.remove('has-purchase-bar');
        return;
      }

      body.style.setProperty('--purchase-bar-space', bar.offsetHeight + 'px');
      body.classList.add('has-purchase-bar');
    }

    layout();

    if (mobile.addEventListener) {
      mobile.addEventListener('change', layout);
    } else {
      mobile.addListener(layout);
    }

    if (window.ResizeObserver) {
      new ResizeObserver(layout).observe(bar);
    } else {
      window.addEventListener('resize', layout);
    }
  }

  // 開いたらボタンは消し、開いた先頭の商品にフォーカスを移す
  function initRelated(root) {
    var related = root.querySelector('[data-related]');
    var more = root.querySelector('[data-related-more]');

    if (!related || !more) {
      return;
    }

    more.addEventListener('click', function() {
      var first = related.querySelector('.product-related__item--more a');

      related.classList.remove('is-collapsed');
      more.parentNode.removeChild(more);

      if (first) {
        first.focus();
      }
    });
  }

  document.querySelectorAll('[data-product-purchase]').forEach(init);

  // テーマエディタでセクションが描き直されたとき
  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('[data-product-purchase]');

    if (root) {
      init(root);
    }
  });
})();
